import React, { useEffect, useState } from "react";
import { Handshake } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const SponsorItem = ({ sponsor }) => {
  const inner = (
    <div
      className="flex items-center justify-center gap-3 h-16 px-6 mx-3 rounded border border-gold/20 bg-black/60 hover:border-gold/60 transition-colors"
      title={sponsor.name}
    >
      {sponsor.logo_url ? (
        <img
          src={sponsor.logo_url}
          alt={sponsor.name}
          className="h-10 w-auto object-contain"
          loading="lazy"
        />
      ) : (
        <span className="font-condensed uppercase tracking-[0.25em] text-sm text-gold whitespace-nowrap">
          {sponsor.name}
        </span>
      )}
    </div>
  );
  return sponsor.url ? (
    <a
      href={sponsor.url}
      target="_blank"
      rel="noopener noreferrer sponsored"
      data-testid={`sponsor-link-${sponsor.id}`}
      className="shrink-0"
    >
      {inner}
    </a>
  ) : (
    <div className="shrink-0" data-testid={`sponsor-item-${sponsor.id}`}>
      {inner}
    </div>
  );
};

const SponsorRotator = () => {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    let alive = true;
    fetch(`${BACKEND}/api/sponsors`)
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => alive && setSponsors(data))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (sponsors.length === 0) return null;

  // Duplicate the list so the marquee scrolls seamlessly
  const track = [...sponsors, ...sponsors];

  return (
    <section
      data-testid="sponsor-rotator"
      className="relative max-w-7xl mx-auto px-5 md:px-10 mt-24"
    >
      <div className="rounded-lg border border-gold/20 bg-jet-surface/60 backdrop-blur-sm p-8 md:p-10">
        <div className="grid md:grid-cols-[1fr_2fr] gap-6 items-center">
          <div>
            <div className="flex items-center gap-2 font-condensed uppercase tracking-[0.35em] text-[11px] text-gold">
              <Handshake className="w-3.5 h-3.5" />
              Powered By
            </div>
            <h3 className="mt-2 font-display text-3xl uppercase text-white">
              Our <span className="text-gold-gradient">Sponsors</span>
            </h3>
            <p className="font-body text-sm text-neutral-400 mt-2 max-w-md">
              Independent brands & families supporting the culture. Tap a logo to visit them.
            </p>
          </div>
          <div className="relative overflow-hidden">
            <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-jet-surface to-transparent z-10" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-jet-surface to-transparent z-10" />
            <div
              className="flex sponsor-marquee"
              style={{ animation: `sponsor-scroll ${Math.max(16, sponsors.length * 4)}s linear infinite` }}
            >
              {track.map((s, i) => (
                <SponsorItem key={`${s.id}-${i}`} sponsor={s} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SponsorRotator;
